<template lang="pug">
  include ./../../../mixins
  +b.popup-inner.modal-form-community
    +e.close-popup(@click='closeModal()')
    +b.wrap
      +b.el--p_r_md-till-xl
        +b.H3.ds-caption--size_30xl-md.--size_lg.--w_r.--c_white.--h_130.--upp {{title}}
      +b.el--p_t_2sm-md.--p_t_sm-sm.--p_t_1xs
        +b.P.ds-caption--c_white.--op-4-md.--w_l.--size_md-md.--size_1xs-sm.--h_200-md.--h_180(
          class="ds-caption--size_xs"
          v-html="subtitle"
        )
      +b.outliner.join-team
        get-form-consultation(
          @updateParent="closeModal"
          :title="fromTitle"
          :trans-group="trans"
        )
    slot(
      name="content"
    )
</template>

<script>

export default {
  data() {
    return {
      trans: {},
    }
  },
  props: {
    title: {},
    subtitle: {},
    fromTitle: {},
    transGroup: {},
  },
  mounted() {
    this.trans = JSON.parse(this.transGroup)
  },
  methods: {
    closeModal() {
      this.$nextTick(() => {
        this.$emit('close')
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/Modals/ModalConsultation.vue